import React from 'react'
import classNames from 'classnames'

import css from './LoadingDots.styles.scss'

import { LoadingDotsProps } from './LoadingDots.types'

const LoadingDots: React.FC<LoadingDotsProps> = ({
  className,
  ariaHidden = false,
}) => {
  const LoadingDotsClasses = classNames(css.LoadingDots, className)

  return (
    <div
      aria-hidden={ariaHidden}
      aria-label="Loading"
      className={LoadingDotsClasses}
      role="status"
    >
      <div className={css.loading_dot} />
      <div className={css.loading_dot} />
      <div className={css.loading_dot} />
    </div>
  )
}

export default LoadingDots
